import { useEffect, useState } from "react";

export const useMobileMenu = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        const burgerMenu = document.querySelector('[data-role="BurgerMenu"]');
        const mobileMenu = document.querySelector('[data-role="MobileMenu"]');
        const closeMobileMenu = document.querySelector('[data-role="CloseMobileMenu"]');

        const showMobileMenu = () => {
            if (mobileMenu) {
                mobileMenu.style.display = "flex";
            }
            setIsMobileMenuOpen(true);
        };

        const hideMobileMenu = () => {
            if (mobileMenu) {
                mobileMenu.style.display = "none";
            }
            setIsMobileMenuOpen(false);
        };

        if (burgerMenu) {
            burgerMenu.addEventListener("click", showMobileMenu);
        }
        if (closeMobileMenu) {
            closeMobileMenu.addEventListener("click", hideMobileMenu);
        }
        if (mobileMenu) {
            mobileMenu.addEventListener("click", e => {
                if (e.target === mobileMenu) {
                    hideMobileMenu();
                }
            });
        }

        return () => {
            if (burgerMenu) burgerMenu.removeEventListener("click", showMobileMenu);
            if (closeMobileMenu) closeMobileMenu.removeEventListener("click", hideMobileMenu);
            if (mobileMenu) {
                mobileMenu.removeEventListener("click", hideMobileMenu);
            }
        };
    }, []);

    return {
        isMobileMenuOpen,
        toggleMobileMenu
    };
};
